import { NgModule } from '@angular/core';
import { RSCommonModule } from '../core/feature-modules/facade.module';
import { AbpManagementComponent } from './abp-management.component';
import { AbpManagementRoutingModule } from './abp-managment.routing';
// import { AbpPhotoModule } from './abp-tab-photo/gbp-tab-photo.module';
import { AbpPostModule } from './abp-tab-post/abp-tab-post.module';
// import { AbpQaModule } from './gbp-tab-qa/gbp-tab-qa.module';

@NgModule({
  declarations: [AbpManagementComponent],
  exports: [AbpManagementComponent],
  imports: [RSCommonModule, AbpManagementRoutingModule, AbpPostModule],
  providers: [],
})
export class AbpManagementModule {}
